module.exports = __webpack_public_path__ + "fde40cfef7c96272aeb80bb04d3991d6.pdf";